import { selectFromRouteConstraintDto } from '../../models';

export default selectFromRouteConstraintDto()
  .capacity
  .duration
  .startTime
  .endTime
  .startLocations(startLocation => startLocation.address.latitude.longitude.active.bestMatch.locationStatusId)
  .endLocations(startLocation => startLocation.address.latitude.longitude.active.bestMatch.locationStatusId)
  .toString();
